exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-certificate[data-v-3316bf23] {\n  white-space: normal !important;\n}\n.certificate[data-v-3316bf23] {\n  min-height: 50px;\n  min-width: 50px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3316bf23","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/policyholder/PolicyHolderDetails.vue
// module id = chkr
// module chunks = 1